import type React from 'react';

export type Message = {
  prefix?: string;
  content: string | React.ReactNode;
  level: 'INFO' | 'ERROR' | 'SUCCESS' | 'WARNING';
};

export const StandardMessageHeader = ({
  message,
  style = {},
}: {
  message: Message | undefined;
  style?: React.CSSProperties;
}) => {
  if (!message) return null;

  let color = 'bg-amber-500';
  if (message.level === 'ERROR') {
    color = 'bg-red-500';
  } else if (message.level === 'SUCCESS') {
    color = 'bg-green-500';
  }

  return (
    <div
      className={`w-full ${color} px-10 py-1 leading-[1.5rem] text-white`}
      style={style}
    >
      <strong>
        {message.prefix ? message.prefix : 'Status Message:'}
        {` `}
      </strong>
      {message.content}
    </div>
  );
};
